<template>
  <v-card class="mx-auto" max-width="400">
    <v-img
      class="white--text align-end"
      height="200px"
      src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
    >
      <v-card-title>Turki</v-card-title>
    </v-img>

    <v-card-subtitle class="pb-0"> Number 10 </v-card-subtitle>

    <v-card-text class="text--primary">
      <div>Whitehaven Beach</div>

      <div>Whitsunday Island, Whitsunday Islands</div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        to="/package"
        color="grey lighten-2 text--secondary"
        depressed
        small
      >
        Details
      </v-btn>

      <v-btn color="deep-orange darken-1" depressed small dark>
        Book Now
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["paket"]
};
</script>

<style></style>
